import * as _ from "lodash";
import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { CollectionPurposeDataProvider } from "../../data-provider/collection-purpose.dp";

let DataProtectionOfficerDialogComponent = {
    selector: "vcDataProtectionOfficerDialog",
    templateUrl:
        "/angular/components/collection-purpose/data-protection-officer-dialog.component.html",
    bindings: {
        officer: "=?",
    },
    controller: class DataProtectionOfficerDialogController {
        // * bindings for typescript compiler *
        public officer?: any;
        // ************************************

        private dialog: DialogUtils;
        private dataProvider: CollectionPurposeDataProvider;
        private toast: ToastUtils;
        public otitle: string = "DATA PROTECTION OFFICER";

        constructor(
            DialogUtils: DialogUtils,
            CollectionPurposeDataProvider: CollectionPurposeDataProvider,
            ToastUtils: ToastUtils
        ) {
            this.dialog = DialogUtils;
            this.dataProvider = CollectionPurposeDataProvider;
            this.toast = ToastUtils;
        }

        $onInit() {
            this.officer = _.cloneDeep(this.officer);
        }

        cancel(): void {
            this.dialog.cancel();
        }

        createUpdateOfficer(officer: any): void {
            if (officer.officerid) {
                this.dataProvider.updateOfficer(officer).then(
                    (returnedOfficer: any) => {
                        returnedOfficer.message = "Officer Updated";
                        this.dialog.hide(returnedOfficer);
                    },
                    (error: object) => this.toast.error(error)
                );
            } else {
                officer.otitle = this.otitle;
                this.dataProvider.createOfficer(officer).then(
                    (returnedOfficer: any) => {
                        returnedOfficer.message = "Officer Created";
                        this.dialog.hide(returnedOfficer);
                    },
                    (error: object) => this.toast.error(error)
                );
            }
        }
    },
};

angular
    .module("collectionpurpose")
    .component(
        DataProtectionOfficerDialogComponent.selector,
        DataProtectionOfficerDialogComponent
    );
